import { useState, useEffect } from "react";
import user1 from "../assets/Frame 399.png"; // Replace with your actual image path

const testimonials = [
  {
    text: `I reported an open manhole on my street...`,
    name: "Blessing M., Enugu",
    image: user1,
    colors: {
      foreground: "#031006",
      layer1: "#247A37",
      layer2: "#5A0588",
    },
  },
  {
    text: `Reporting unsafe power lines...`,
    name: "Chinedu A., Lagos",
    image: user1,
    colors: {
      foreground: "#247A37",
      layer1: "#5A0588",
      layer2: "#031006",
    },
  },
  {
    text: `Blocked drains used to be ignored...`,
    name: "Amina S., Kano",
    image: user1,
    colors: {
      foreground: "#5A0588",
      layer1: "#031006",
      layer2: "#247A37",
    },
  },
];

function TestimonialsSection() {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % testimonials.length);
    }, 7000);
    return () => clearInterval(interval);
  }, []);

  const current = testimonials[index];

  return (
    <section
      style={{
        height: "600px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
      className="py-5 d-flex justify-center  bg-white position-relative overflow-hidden"
    >
      <div className="container text-center">
        <h2 className="fw-bold mb-5">What Our Users Are Saying</h2>

        <div
          className="position-relative mx-auto"
          style={{ maxWidth: "850px", height: "auto" }}
        >
          {/* Shadow Layers - Secondary (bottom), Primary (middle) */}
          <div
            className="position-absolute  h-100 rounded-4"
            style={{
              top: "-30px",
              left: "0px",
              right: "0px",
              margin: "0 auto",
              width: "95%",
              backgroundColor: current.colors.layer2,
              transition: "background-color 0.5s ease",
              zIndex: 0,
            }}
          />
          <div
            className="position-absolute  h-100 rounded-4"
            style={{
              top: "-20px",
              left: "0px",
              right: "0px",
              margin: "0 auto",
              backgroundColor: current.colors.layer1,
              transition: "background-color 0.5s ease",
              zIndex: 1,
              width: "98%",
            }}
          />

          {/* Foreground Card */}
          <div
            className="testimonial-card text-white p-4 rounded-4 position-relative d-flex flex-column flex-lg-row align-items-center justify-content-between"
            style={{
              backgroundColor: current.colors.foreground,
              zIndex: 2,
              transition: "background-color 0.4s ease",
            }}
          >
            <div className="text-start">
              <p className="fst-italic fs-5 mb-2">“{current.text}”</p>
              <p className="fw-semibold mb-0">— {current.name}</p>
            </div>
            <div className="mt-3 mt-lg-0 ms-lg-4">
              <img
                src={current.image}
                alt={current.name}
                className="rounded-4"
                style={{ width: "100px", height: "100px", objectFit: "cover" }}
              />
            </div>
          </div>
        </div>

        {/* Navigation */}
        <div className="d-flex justify-content-center gap-3 mt-4">
          <button
            className="btn btn-outline-dark rounded-circle"
            style={{ width: "40px", height: "40px" }}
            onClick={() =>
              setIndex(
                (prev) => (prev - 1 + testimonials.length) % testimonials.length
              )
            }
          >
            ←
          </button>
          <button
            className="btn btn-light rounded-circle"
            style={{ width: "40px", height: "40px" }}
            onClick={() => setIndex((prev) => (prev + 1) % testimonials.length)}
          >
            →
          </button>
        </div>

        {/* Dots */}
        <div className="d-flex justify-content-center gap-2 mt-3">
          {testimonials.map((_, i) => (
            <span
              key={i}
              className={`rounded-circle ${
                i === index ? "bg-dark" : "bg-secondary"
              }`}
              style={{
                width: "10px",
                height: "10px",
                display: "inline-block",
                transition: "background-color 0.3s ease",
              }}
            />
          ))}
        </div>
      </div>
    </section>
  );
}

export default TestimonialsSection;
